import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          {/* <p className="text-sm text-designColor tracking-[4px]">2007 - 2010</p>
          <h2 className="text-4xl font-bold">Company Experience</h2> */}
        </div>
        <div className=" w-full h-[830px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Master of Delivery at Amazon"
            result={<span style={{ color: '#38b2ac' }}>2022</span>}
            des="Awarded Master of Delivery at Amazon for timely design and deployment of the SSL project in the JP region."
          />
          <ResumeCard
            title="Engineering Campus Top 20 for CGPA"
            result={<span style={{ color: '#38b2ac' }}>2021</span>}
            des="Secured a top 20 ranking within the engineering campus for maintaining a high CGPA."
          />
          <ResumeCard
            title="Champion of ACM Student Chapter Coding Competition"
            result={<span style={{ color: '#38b2ac' }}>2020</span>}
            des="Achieved the 1st place ranking in a coding competition organized by the ACM student chapter during my Bachelor’s."
          />
          <ResumeCard
            title="Gold Medal in Joy of Computing using Python"
            result={<span style={{ color: '#38b2ac' }}>2019</span>}
            des="Achieved an impressive 90% in the Joy of Computing using Python course offered by NPTEL, an initiative by IITs."
          />
          <ResumeCard
            title="Gold Medal in Discrete Mathematics"
            result={<span style={{ color: '#38b2ac' }}>2019</span>}
            des="Achieved an impressive 90% in the Discrete Mathematics course offered by NPTEL, an initiative by IITs."
          />
        </div>
      </div>
      {/* <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2007 - 2010</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Lorem ipsum dolor sit amet."
            subTitle="Lorem ipsum dolor sit amet alternative."
            result="Success"
            des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora itaque accusamus corporis dolor debitis natus sapiente, voluptates possimus minima totam!"
          />
          <ResumeCard
            title="Lorem ipsum dolor sit amet."
            subTitle="Lorem ipsum dolor sit amet alternative."
            result="Success"
            des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora itaque accusamus corporis dolor debitis natus sapiente, voluptates possimus minima totam!"
          />
          <ResumeCard
            title="Lorem ipsum dolor sit amet."
            subTitle="Lorem ipsum dolor sit amet alternative."
            result="Success"
            des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora itaque accusamus corporis dolor debitis natus sapiente, voluptates possimus minima totam!"
          />
        </div>
      </div> */}
    </motion.div>
  );
};

export default Achievement;
